import { actionCreator, checkHttpStatus, jsonApiHeader, showSuccessMessage, showWarningMessage } from "../../downLoadClientList/constants/ApiConstants"
import { UploadRawDataActionTypes, POST_UPLOADRAWDATAFORTARGETS,POST_UPLOADRAWDATAFORBEHAVIOR} from '../constants/ApiConstants';

export const uploadRawDataTarget = (UploadFile) => {
    return (dispatch,getState) => {
        dispatch(actionCreator(UploadRawDataActionTypes.post_UploadRawDataForTargets.REQUEST));
        fetch(`${POST_UPLOADRAWDATAFORTARGETS}`, {
             method: 'post',
             headers: jsonApiHeader(getState().login.access_token, 'application/json'),
             body: JSON.stringify(UploadFile),
           })
             .then(checkHttpStatus)
             .then(function(response) {        
               if (response.statusCode === 200) {
                 showSuccessMessage(response.message);
               } else if (response.statusCode === 422) {
                 showWarningMessage(response.message);
               } else {
                 dispatch(actionCreator(UploadRawDataActionTypes.post_UploadRawDataForTargets.FAILURE, response.message));
                 //showErrorMessage(response.message);
               }      
             })
             .catch(function(error) {
               console.log('error-----', error);
             });
    }
};
export const uploadRawDataBehavior = (UploadFile) => {
    return (dispatch,getState) => {
        dispatch(actionCreator(UploadRawDataActionTypes.post_UploadRawDataForBehavior.REQUEST));
        fetch(`${POST_UPLOADRAWDATAFORBEHAVIOR}`, {
             method: 'post',
             headers: jsonApiHeader(getState().login.access_token, 'application/json'),
             body: JSON.stringify(UploadFile),
           })
             .then(checkHttpStatus)
             .then(function(response) {        
               if (response.statusCode === 200) {
                 showSuccessMessage(response.message);
               } else if (response.statusCode === 422) {
                 showWarningMessage(response.message);
               } else {
                 dispatch(actionCreator(UploadRawDataActionTypes.post_UploadRawDataForBehavior.FAILURE, response.message));
                 //showErrorMessage(response.message);
               }      
             })
             .catch(function(error) {
               console.log('error-----', error);
             });
    }
};


// WEBPACK FOOTER //
// ./src/modules/MastersDataCollection/settings/uploadExcel/uploadRawData/actions/downloadTargetAction.js